import type { ComponentType } from 'react'
import { useTranslation } from 'react-i18next'

import type { OrderStatus } from '@/api/orders'
import {
  IconAlert,
  IconBox,
  IconCheck,
  IconClipboard,
  IconClock,
  IconClose,
  IconInbox,
} from '@/components/icons'
import { STATUS_TONES } from '@/features/orders/status'

/**
 * Εικονίδιο ανά κατάσταση, από το ίδιο σετ με την υπόλοιπη εφαρμογή.
 *
 * Τα παλιά σύμβολα κειμένου («→», «≈», «👁») άλλαζαν όψη ανά συσκευή και το
 * «≈» δεν σήμαινε τίποτα για κάποιον που δεν ξέρει τι θα πει «περίπου».
 */
const STATUS_ICONS: Record<OrderStatus, ComponentType<{ size?: number; className?: string }>> = {
  draft: IconClipboard,
  sent: IconClock,
  received: IconInbox,
  confirmed: IconCheck,
  partially_confirmed: IconAlert,
  delivered: IconBox,
  cancelled: IconClose,
}

export function StatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation()
  const Icon = STATUS_ICONS[status]
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium ${STATUS_TONES[status]}`}
    >
      <Icon size={13} aria-hidden />
      {t(`orders.status.${status}`)}
    </span>
  )
}
